var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgXLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.4203 14.009L27.8913 3H25.6473L17.4233 12.559L10.8553 3H3.28027L13.2123 17.455L3.28027 29H5.52427L14.2083 18.905L21.1443 29H28.7203L18.4203 14.009ZM15.3463 17.582L14.3403 16.143L6.33327 4.69H9.78027L16.2423 13.933L17.2483 15.372L25.6483 27.387H22.2013L15.3473 17.583L15.3463 17.582Z",
    fill: "#E8E8E8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXLink);
export default __webpack_public_path__ + "static/media/xLink.ef8511b47b8e3c450b7099ed5aa31f83.svg";
export { ForwardRef as ReactComponent };